export default "__VITE_ASSET__0ea38302__"